import { type ReactElement, type ReactNode, useEffect, useState, ChangeEvent } from "react"
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/app/store";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Modal from "src/components/Modal";
import { OrderType } from "src/features/orderManagement/types/OrderType";
import Button from "src/components/Button";

export interface OrderModalProps {
        title: string,
        isOpen: boolean,
        selectedOrder: OrderType | undefined,
        onClose: () => void,
        PrintClick: () => void,
        children?: ReactNode
}

export default function OrderModal(props: OrderModalProps): ReactElement {
        const { register, control, setError, formState: { errors, isSubmitting } } = useForm<OrderType>({
                defaultValues: props.selectedOrder
        });

        useEffect(() => {
        }, [])

        return <>
                <Modal isOpen={props.isOpen} onClose={props.onClose}>
                        <h2 className="text-lg font-bold">
                                {props.title}
                        </h2>
                        <form>
                                <div>
                                        <div className="mb-4">
                                                <label className="block text-sm">Order Id</label>
                                                <input className="w-full px-3 py-2 border rounded-lg" {...register("OrderId",)} />
                                        </div>
                                        <div className="mb-4">
                                                <label className="block text-sm">Dealer</label>
                                                <input className="w-full px-3 py-2 border rounded-lg" {...register("DealerName",)} />
                                        </div>
                                        <div className="mb-4">
                                                <label className="block text-sm">EndUser</label>
                                                <input className="w-full px-3 py-2 border rounded-lg" {...register("EndUserName",)} />
                                        </div>
                                        <div className="mb-4">
                                                <label className="block text-sm">EndUserInstance</label>
                                                <input className="w-full px-3 py-2 border rounded-lg" {...register("EndUserInstanceName",)} />
                                        </div>
                                        <div className="mb-4">
                                                <label className="block text-sm">EndUserInstanceLocation</label>
                                                <input className="w-full px-3 py-2 border rounded-lg" {...register("EndUserInstanceLocationName",)} />
                                        </div>
                                        <div className="mb-4">
                                                <label className="block text-sm">Number of Doors</label>
                                                <input className="w-full px-3 py-2 border rounded-lg" {...register("NumberOfDoors",)} />
                                        </div>
                                        <div className="mb-4">
                                                <label className="block text-sm">Order Date</label>
                                                <input className="w-full px-3 py-2 border rounded-lg" {...register("OrderDate",)} />
                                        </div>
                                </div>
                                <div className="flex gap-16 justify-around">
                                        <Button className="" size="lg" type="button" buttonStyle="primary" handleClick={props.PrintClick}>Print</Button>
                                </div>
                        </form>
                        {errors.root && (
                                <div className="text-red-500 text-center">{errors.root.message}</div>
                        )}
                </Modal>
        </>
}
